import { __awaiter, __generator, __read } from "tslib";
import { warmup3S, warmupMsb, warmupPersonalData, warmupPersonalRankingContext, } from '.';
/**
 * Fire and forget prefetching/init calls from SERP.
 */
export function runPrefetchCalls(_a) {
    var searchPrefetch = _a.searchPrefetch, searchInstrumenter = _a.searchInstrumenter, searchSettings = _a.searchSettings, searchDispatcher = _a.searchDispatcher, searchHostAppLogger = _a.searchHostAppLogger;
    return __awaiter(this, void 0, void 0, function () {
        var _b, instrumenter, identity, searchConfig, isMsa, fastUseSubstrateEnabled;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, Promise.all([
                        searchInstrumenter.getModule(),
                        searchSettings.getIdentity(),
                        searchSettings.getSearchConfig(),
                    ])];
                case 1:
                    _b = __read.apply(void 0, [_c.sent(), 3]), instrumenter = _b[0], identity = _b[1], searchConfig = _b[2];
                    isMsa = identity.isMsa;
                    fastUseSubstrateEnabled = searchConfig.fastUseSubstrateEnabled;
                    if (isMsa) {
                        // No prefetching calls are supported for MSA
                        return [2 /*return*/];
                    }
                    // Mark the beginning of the prefetch calls
                    instrumenter.mark('SerpPrefetchStart');
                    Promise.all([
                        warmupPersonalData({
                            searchPrefetch: searchPrefetch,
                            searchDispatcher: searchDispatcher,
                            searchSettings: searchSettings,
                        }),
                        warmupMsb({
                            searchPrefetch: searchPrefetch,
                            searchSettings: searchSettings,
                        }),
                        warmup3S({
                            searchPrefetch: searchPrefetch,
                            searchSettings: searchSettings,
                            searchHostAppLogger: searchHostAppLogger,
                        }),
                        // Personal ranking context warmup is only called when 3S is disabled
                        !fastUseSubstrateEnabled &&
                            warmupPersonalRankingContext({
                                searchPrefetch: searchPrefetch,
                                searchSettings: searchSettings,
                                searchHostAppLogger: searchHostAppLogger,
                            }),
                    ]).then(function () {
                        // Mark the end of the prefetch calls
                        instrumenter.mark('SerpPrefetchDone');
                    });
                    return [2 /*return*/];
            }
        });
    });
}
//# sourceMappingURL=runPrefetchCalls.js.map